import { Box, Stack, Typography, Paper, Chip, alpha } from "@mui/material";
import { ArrowForward as ArrowIcon } from "@mui/icons-material";
import { renderChangeValue } from "./Helpers";

export const DetailedChanges = ({ data }) => {
  if (!data || Object.keys(data).length === 0) {
    return (
      <Box
        sx={{
          textAlign: "center",
          py: 3,
          bgcolor: "#FFFFFF",
          borderRadius: "8px",
          border: "1px solid #E2E8F0",
        }}
      >
        <Typography color="#94A3B8" sx={{ fontSize: "0.82rem" }}>
          No changes available
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={1.5} sx={{ width: "100%" }}>
      {Object.entries(data).map(([field, values]) => (
        <Paper
          key={field}
          elevation={0}
          sx={{
            p: 2,
            borderRadius: "8px",
            bgcolor: "#FFFFFF",
            border: "1px solid #E2E8F0",
            width: "100%",
            transition: "all 0.15s ease-in-out",
            "&:hover": {
              borderColor: alpha("#2469F0", 0.4),
              boxShadow: "0px 2px 8px rgba(36, 105, 240, 0.08)",
            },
          }}
        >
          {/* FIELD LABEL */}
          <Chip
            label={field}
            size="small"
            sx={{
              fontWeight: 600,
              bgcolor: alpha("#2469F0", 0.08),
              color: "#2469F0",
              fontSize: "0.7rem",
              height: 22,
              mb: 1.5,
              textTransform: "capitalize",
            }}
          />

          {/* OLD / NEW LAYOUT */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            alignItems="stretch"
          >
            {/* PREVIOUS */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 700,
                  color: "#94A3B8",
                  fontSize: "0.65rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.3px",
                  mb: 0.5,
                  display: "block",
                }}
              >
                Previous
              </Typography>
              <Box
                sx={{
                  p: 1.5,
                  borderRadius: "6px",
                  bgcolor: "#F8FAFC",
                  border: "1px solid #E2E8F0",
                  minHeight: 36,
                  overflowWrap: "break-word",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: "#475467", fontSize: "0.78rem" }}
                >
                  {renderChangeValue(values?.old || "")}
                </Typography>
              </Box>
            </Box>

            {/* ARROW */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: 0.5,
              }}
            >
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  bgcolor: alpha("#2469F0", 0.08),
                  color: "#2469F0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ArrowIcon sx={{ fontSize: 14 }} />
              </Box>
            </Box>

            {/* UPDATED */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 700,
                  color: "#94A3B8",
                  fontSize: "0.65rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.3px",
                  mb: 0.5,
                  display: "block",
                }}
              >
                Updated
              </Typography>
              <Box
                sx={{
                  p: 1.5,
                  borderRadius: "6px",
                  bgcolor: alpha("#22C55E", 0.05),
                  border: "1px solid",
                  borderColor: alpha("#22C55E", 0.2),
                  minHeight: 36,
                  overflowWrap: "break-word",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: "#475467", fontSize: "0.78rem" }}
                >
                  {renderChangeValue(values?.new || "")}
                </Typography>
              </Box>
            </Box>
          </Stack>
        </Paper>
      ))}
    </Stack>
  );
};